import React, { useState } from "react";
import { Container, Row, Col, Card, Button, Dropdown } from "react-bootstrap";
import { FiClock, FiMessageCircle } from "react-icons/fi";
import ReplyModal from "../../../components/modals/hrm/tickets/ReplyModal";
import TicketDetailsHeader from "../../../components/crm/tickets/TicketDetailsHeader";
import { FiChevronDown, FiSettings } from "react-icons/fi";
const TicketDetails = () => {
  const [showReply, setShowReply] = useState(false);

  const [replies, setReplies] = useState([
    {
      name: "James Hendriques",
      img: "/assets/img/users/user-09.jpg",
      message:
        "This issue disrupts meetings, delays task completion, and affects my overall productivity.",
      time: "Updated 5 hours ago",
    },
  ]);

  const addReply = (msg) => {
    setReplies([
      ...replies,
      {
        name: "You",
        img: "/assets/img/users/user-01.jpg",
        message: msg,
        time: "Just now",
      },
    ]);
  };

  return (
    <Container fluid style={{ padding: "15px", background: "#f8f9fa",  }}>
      <TicketDetailsHeader />

      <Row>
        {/* LEFT */}
        <Col xl={9} md={8} sm={12}>
          <Card style={{ borderRadius: "8px", border: "1px solid #eee" }}>
            
            {/* TOP HEADER */}
            <Card.Header
              style={{
                background: "#fff",
                borderBottom: "1px solid #eee",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "10px",
              }}
            >
              <h6 style={{ color: "#0dcaf0", margin: 0 }}>IT Support</h6>

              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <span
                  style={{
                    background: "#ff0000",
                    color: "#fff",
                    padding: "4px 12px",
                    borderRadius: "20px",
                    fontSize: "12px",
                  }}
                >
                  • High
                </span>

                <Dropdown>
                  <Dropdown.Toggle className="text-dark"
                    style={{
                      background: "#fff",
                      border: "1px solid #ddd",
                      fontSize: "13px",
                    }}
                  >
                    Mark as Private
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item>Mark as Private</Dropdown.Item>
                    <Dropdown.Item>Mark as Public</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Card.Header>

            {/* BODY */}
            <Card.Body>
              
              {/* TITLE SECTION */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  borderBottom: "1px solid #eee",
                  paddingBottom: "15px",
                  marginBottom: "15px",
                }}
              >
                <div>
                  <span
                    style={{
                      background: "#0d6efd",
                      color: "#fff",
                      padding: "3px 10px",
                      borderRadius: "20px",
                      fontSize: "11px",
                    }}
                  >
                    Tic - 001
                  </span>

                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "6px" }}>
                    <h5 style={{ margin: 0 }}>Laptop Issue</h5>

                    <span
                      style={{
                        border: "1px solid #ff4d6d",
                        color: "#ff4d6d",
                        padding: "2px 8px",
                        borderRadius: "12px",
                        fontSize: "11px",
                      }}
                    >
                      ● Open
                    </span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: "10px",
                      fontSize: "13px",
                      color: "#666",
                      marginTop: "6px",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src="/assets/img/profiles/avatar-06-1.jpg"
                        alt=""
                        style={{
                          width: "22px",
                          height: "22px",
                          borderRadius: "50%",
                          marginRight: "6px",
                        }}
                      />
                      Assigned to <b style={{ marginLeft: "4px" }}>Juan Hermann</b>
                    </div>

                    <span>
                      <FiClock /> Updated 20 hours ago
                    </span>

                    <span>
                      <FiMessageCircle /> 9 Comments
                    </span>
                  </div>
                </div>

                <Button
                  onClick={() => setShowReply(true)}
                  style={{
                    background: "#ff6b00",
                    border: "none",
                    height: "40px",
                  }}
                >
                  ↗ Post a Reply
                </Button>
              </div>

              {/* DESCRIPTION */}
              <p style={{ fontSize: "14px", color: "#555" }}>
                For the past week, my laptop has been experiencing intermittent freezing issues...
              </p>

              {/* COMMENTS */}
              {replies.map((r, i) => (
                <div
                  key={i}
                  style={{
                    borderTop: "1px solid #eee",
                    paddingTop: "15px",
                    marginTop: "15px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                    <img
                      src={r.img}
                      alt=""
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        marginRight: "10px",
                      }}
                    />
                    <div>
                      <h6 style={{ margin: 0 }}>{r.name}</h6>
                      <small style={{ color: "#888" }}>
                        <FiClock /> {r.time}
                      </small>
                    </div>
                  </div>

                  <p style={{ marginLeft: "50px" }}>{r.message}</p>

                  <div
                    style={{
                      display: "flex",
                      gap: "15px",
                      marginLeft: "50px",
                      fontSize: "13px",
                    }}
                  >
                    <span
                      style={{ color: "#ff6b00", cursor: "pointer" }}
                      onClick={() => setShowReply(true)}
                    >
                      ↗ Reply
                    </span>

                    <span style={{ color: "#666" }}>
                      <FiMessageCircle /> 1 Comments
                    </span>
                  </div>
                </div>
              ))}
            </Card.Body>
          </Card>
        </Col>

        {/* RIGHT */}
    <Col xl={3} md={4} sm={12}>
  <div style={{ position: "relative" }}>
    
    {/* FLOATING SETTINGS ICON */}
    <div
      style={{
        position: "absolute",
        right: "-10px",
        top: "80px",
        background: "#ff6b00",
        width: "32px",
        height: "32px",
        borderRadius: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        cursor: "pointer",
        zIndex: 10,
      }}
    >
      <FiSettings size={16} />
    </div>

    <Card style={{ borderRadius: "8px", border: "1px solid #e5e7eb" }}>
      
      {/* HEADER */}
      <Card.Header
        style={{
          background: "#fff",
          borderBottom: "1px solid #eee",
          padding: "12px 15px",
        }}
      >
        <h6 style={{ margin: 0, fontWeight: "600" }}>Ticket Details</h6>
      </Card.Header>

      <Card.Body style={{ padding: 0 }}>

        {/* FORM SECTION */}
        <div style={{ padding: "15px", borderBottom: "1px solid #eee" }}>

          {/* PRIORITY */}
          <div style={{ marginBottom: "12px" }}>
            <label style={{ fontSize: "13px", color: "#6c757d" }}>
              Change Priority
            </label>

            <div style={{ position: "relative" }}>
              <select
                style={{
                  width: "100%",
                  padding: "8px 30px 8px 10px",
                  borderRadius: "6px",
                  border: "1px solid #ddd",
                  fontSize: "14px",
                  appearance: "none",
                }}
              >
                <option>High</option>
                <option>Medium</option>
                <option>Low</option>
              </select>

              <FiChevronDown
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#999",
                }}
              />
            </div>
          </div>

          {/* ASSIGN */}
          <div style={{ marginBottom: "12px" }}>
            <label style={{ fontSize: "13px", color: "#6c757d" }}>
              Assign To
            </label>

            <div style={{ position: "relative" }}>
              <select
                style={{
                  width: "100%",
                  padding: "8px 30px 8px 10px",
                  borderRadius: "6px",
                  border: "1px solid #ddd",
                  fontSize: "14px",
                  appearance: "none",
                }}
              >
                <option>Edgar Hansel</option>
                <option>Juan Hermann</option>
              </select>

              <FiChevronDown
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#999",
                }}
              />
            </div>
          </div>

          {/* STATUS */}
          <div>
            <label style={{ fontSize: "13px", color: "#6c757d" }}>
              Ticket Status
            </label>

            <div style={{ position: "relative" }}>
              <select
                style={{
                  width: "100%",
                  padding: "8px 30px 8px 10px",
                  borderRadius: "6px",
                  border: "1px solid #ddd",
                  fontSize: "14px",
                  appearance: "none",
                }}
              >
                <option>Open</option>
                <option>On Hold</option>
                <option>Closed</option>
              </select>

              <FiChevronDown
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#999",
                }}
              />
            </div>
          </div>
        </div>

        {/* USER */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "15px",
            borderBottom: "1px solid #eee",
          }}
        >
          <img
            src="/assets/img/users/user-01-1.jpg"
            alt=""
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              marginRight: "10px",
            }}
          />
          <div>
            <div style={{ fontSize: "12px", color: "#6c757d" }}>User</div>
            <div style={{ fontWeight: "500" }}>Anthony Lewis</div>
          </div>
        </div>

        {/* SUPPORT */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "15px",
            borderBottom: "1px solid #eee",
          }}
        >
          <img
            src="/assets/img/users/user-05.jpg"
            alt=""
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              marginRight: "10px",
            }}
          />
          <div>
            <div style={{ fontSize: "12px", color: "#6c757d" }}>
              Support Agent
            </div>
            <div style={{ fontWeight: "500" }}>Edgar Hansel</div>
          </div>
        </div>

        {/* CATEGORY */}
        <div style={{ padding: "15px", borderBottom: "1px solid #eee" }}>
          <div style={{ fontSize: "12px", color: "#6c757d" }}>Category</div>
          <div style={{ fontWeight: "500" }}>Repair & Service</div>
        </div>

        {/* EMAIL */}
        <div style={{ padding: "15px", borderBottom: "1px solid #eee" }}>
          <div style={{ fontSize: "12px", color: "#6c757d" }}>Email</div>
          <div style={{ color: "#0d6efd" }}>[email protected]</div>
        </div>

        {/* DATE */}
        <div style={{ padding: "15px" }}>
          <div style={{ fontSize: "12px", color: "#6c757d" }}>
            Last Updated / Closed On
          </div>
          <div style={{ fontWeight: "500" }}>25 May 2024</div>
        </div>

      </Card.Body>
    </Card>
  </div>
</Col>
      </Row>

      <ReplyModal
        show={showReply}
        handleClose={() => setShowReply(false)}
        onSend={addReply}
      />
    </Container>
  );
};

export default TicketDetails;